<template>
    <Text as="p" size="f-7">
        {{ invalidReason }}. Sections without data have no influence on your overall score, ensuring
        an accurate assessment of your account's performance.
    </Text>
    <Spacer height="2rem" />
    <div class="relative">
        <oTable
            class="table"
            :class="{ 'pdf-shadow-fix': isPdf, 'gradient-overlay': !isPdf }"
            :headers="[
                { key: 'one', width: 160 },
                { key: 'two', width: 96 },
                { key: 'three', width: 98 },
                { key: 'four', width: 96 },
            ]"
            :items="new Array(2).fill({})"
            :border-radius="20"
            :fixed-layout="true"
        >
            <template v-slot:header.one="one">
                <Skeleton :height="16" :width="48" />
            </template>
            <template v-slot:header.two="two">
                <Skeleton :height="16" :width="48" />
            </template>
            <template v-slot:header.three="three">
                <Skeleton :height="16" :width="48" />
            </template>
            <template v-slot:header.four="four">
                <Skeleton :height="16" :width="48" />
            </template>
            <template v-slot:column.one="one">
                <Skeleton :height="16" :width="120" />
            </template>
            <template v-slot:column.two="two">
                <Skeleton :height="16" :width="60" />
            </template>
            <template v-slot:column.three="three">
                <Skeleton :height="16" :width="62" />
            </template>
            <template v-slot:column.four="four">
                <Skeleton :height="16" :width="60" />
            </template>
        </oTable>
    </div>
</template>

<script setup lang="ts">
import { Spacer, Text, oTable } from '@opteo/components-next'
import Skeleton from '@/components/util/Skeleton.vue'

withDefaults(defineProps<{ invalidReason?: string; isPdf: boolean }>(), {
    invalidReason: 'We are unable to find any relevant data for this section',
    isPdf: false,
})
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.table::before {
    content: '';
    position: absolute;
    top: 0;
    left: -4px;
    height: calc(100% + 4px);
    width: calc(100% + 8px);

    z-index: 1;
}

.gradient-overlay::before {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, #ffffff 98%);
}
</style>
